<template>
  <div v-loading="isBusy">
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        element-loading-spinner="el-icon-loading"
    >
      <el-form-item prop="note">
        <el-input
            type="textarea"
            :rows="5"
            placeholder="Add a note ..."
            v-model="form.note"
            class="el-textarea-word-break-normal"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="read_only" v-if="canSetReadOnlyNote" label="Read only">
        <el-switch v-model="form.read_only"></el-switch>
      </el-form-item>
    </el-form>
    <button class="btn btn-purple btn-sm px-4" :disabled="!canStore" @click="store">Store</button>
    <button class="btn btn-secondary btn-sm px-4" @click="cancel">Cancel</button>
  </div>
</template>

<script>
import BaseForm from "../form";

export default {
  extends: BaseForm,

  props: {
    model: {
      type: Object,
      default: function () {
        return {};
      },
    },
    storeUrl: {
      type: String,
    },
    canSetReadOnlyNote: Boolean,
  },

  data() {
    const form = {
      note: null,
      read_only: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
    }
  },

  computed: {
    /**
     * @return {boolean}
     */
    canStore() {
      return this.model.note !== this.form.note ||
          this.model.read_only !== this.form.read_only;
    },
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm({note = null, read_only = false}) {
      this.form = {
        note,
        read_only,
      };
    },

    /**
     * @return {undefined}
     */
    cancel() {
      this.$emit('cancel');
    },
  },
}
</script>
